
<template>
  <a-card :bordered="false">
    <a-steps class="steps" :current="currentTab">
      <a-step v-for="item in steps" :key="item.title" :title="item.title">
      </a-step>
    </a-steps>
    <div class="content">
      <div v-if="currentTab == 0">
        <a-form style="max-width: 500px; margin: 80px auto 0;" :form="form">
          <a-form-item :label="$t('label.company')"  :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-search-select-tag ref="companyInfo" type="list" v-model="form.company" @change="companyChange"  dict="sys_depart,depart_name,org_code,org_category='1' and del_flag = '0'" :placeholder="$t('label.pleaseSelectCompany')" />
          </a-form-item>
          <a-form-item label="账期" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-dict-select-tag type="list" v-model="form.period" :dictCode="accountPeriodDict" placeholder="请选择账期" />
          </a-form-item>
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button type="primary" @click="nextStep">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="currentTab != 0">
        公司：{{form.company}}-{{companyName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;账期：{{form.period}}
      </div>

      <div v-if="currentTab == 1 && currentTab != this.steps.length-1">
        <a-form style="max-width: 500px; margin: 80px auto 0;" :form="form">
          <a-form-item :label="$t('label.materialNumber')" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-dict-select-tag type="list" v-model="form.materialCode"  dictCode="efs_md_material,name,code,mm_grp_code='90199' and valid_flag='Y' and del_flag='N'" :placeholder="$t('label.pleaseSelectTheMaterialNo')"/>
          </a-form-item>

          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button :disabled="retryLoading" @click="prevStep">上一步</a-button>
            <a-button style="margin-left: 8px" :loading="retryLoading" @click="retry">执行</a-button>
            <a-button style="margin-left: 8px" type="primary" :disabled="retryLoading" @click="nextStep">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>

      <div v-if="currentTab == 1 ">
        <a-tabs default-active-key="1" >
          <a-tab-pane key="1" tab="应付单">
            <Efs-Payable-List ref="efsPayableList"></Efs-Payable-List>
          </a-tab-pane>
        </a-tabs>
      </div>

      <div v-if="currentTab == 3 ">
        <a-tabs default-active-key="2" >
          <a-tab-pane key="2" tab="制造费用">
            <Efs-Cost-List ref="efsCostList"></Efs-Cost-List>
          </a-tab-pane>
        </a-tabs>
      </div>



      <div v-if="currentTab != 0 &&currentTab != 1 && currentTab != this.steps.length-1">
        <a-form style="max-width: 500px; margin: 40px auto 0;">

          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button :disabled="retryLoading" @click="prevStep">上一步</a-button>
            <a-button style="margin-left: 8px" :loading="retryLoading" @click="retry">执行</a-button>
            <a-button style="margin-left: 8px" type="primary" :disabled="retryLoading" @click="nextStep">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="currentTab == this.steps.length-1" style="margin: 40px auto 0;">
        <a-form style="max-width: 500px; margin: 40px auto 0;">

          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button :disabled="retryLoading" @click="prevStep">上一步</a-button>
            <a-button style="margin-left: 8px" :loading="retryLoading" @click="retry">执行</a-button>

          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-card>
</template>

<script>
    import { ajaxGetDictItems,getCheckServiceGroup } from '@/api/api'
    import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
    import JDictSelectTag from '@/components/dict/JDictSelectTag'
    import { postJsonAction, getAction } from '@/api/manage'
    import EfsPayableList from './basicItem/EfsPayableList'
    import EfsCostList from './basicItem/EfsCostList'
    import EfsMdDeadAmoyLogList from './basicItem/EfsMdDeadAmoyLogList'

    export default {
        name: "capitalForm",
        components: {
            JSearchSelectTag,
            JDictSelectTag,
            EfsPayableList,
            EfsCostList,
            EfsMdDeadAmoyLogList,
        },
        data() {
            return {
                currentTab: 0,
                accountPeriodDict: null,
                form: {},
                steps: [],
                /*stepLabels: [],*/
                retryLoading: false,
                columns: [
                    {
                        title: '凭证编码',
                        dataIndex: 'accountCode',
                    },
                    {
                        title: '摘要',
                        dataIndex: 'docTitle',
                    },
                    // {
                    //   title: '方向',
                    //   dataIndex: 'key2',
                    // },
                    {
                        title: '科目代码',
                        dataIndex: 'ledgerAccount',
                    },
                    {
                        title: '科目名称',
                        dataIndex: 'accountName',
                    },
                    {
                        title: '金额',
                        dataIndex: 'amount',
                    },
                    {
                        title: '过账码',
                        dataIndex: 'postCode',
                    },
                    {
                        title: '成本中心',
                        dataIndex: 'costCenter',
                    },
                    {
                        title: '内部订单',
                        dataIndex: 'orderCode',
                    },
                    {
                        title: '物料',
                        dataIndex: 'mmCode',
                    },
                    // {
                    //   title: '客户',
                    //   dataIndex: 'customerCode',
                    // },
                    {
                        title: '凭证号',
                        dataIndex: 'docNo',
                    },
                ],
                dataSource: [],
                url: {
                    getSyncInterface: '/cost/sync/getSyncInterface',
                },
                companyName: '',
                serviceGroupCodeName:''
            }
        },
        created() {
            // 接口：
            this.initStep();
        },
        methods: {
            initStep() {
                ajaxGetDictItems('cost_accounting', null).then((res) => {
                    if (res.success) {
                        this.steps = res.result;
                    }
                })
            },
            companyChange(param) {
                this.$refs.companyInfo.options.map(item => {
                    if (item.value == param) {
                        this.companyName = item.title
                    }
                });
                this.accountPeriodDict = "efs_sys_account_period,period_code,period_code,status='U' AND valid_flag = 'Y' AND del_flag = 'N' AND company_code = '" + param + "' order by period_code desc"
            },


            nextStep() {
                if(this.currentTab==0){
                    if (this.form.company && this.form.period) {
                        this.currentTab += 1;
                    }
                }else if(this.currentTab!=0){
                    if (this.form.materialCode) {
                        this.currentTab += 1;
                    }
                }

                this.$nextTick(() => {
                    if(this.currentTab==1){
                        this.$refs.efsPayableList.getOrderMain(this.form.company,this.form.period);
                    }else if(this.currentTab==3){
                        this.$refs.efsCostList.getOrderMain(this.form.company,this.form.period);
                    }
                });
            },

            prevStep() {
                this.currentTab -= 1;
                this.$nextTick(() => {
                    if(this.currentTab==1){
                        this.$refs.efsPayableList.getOrderMain(this.form.company,this.form.period);
                    }else if(this.currentTab==3){
                        this.$refs.efsCostList.getOrderMain(this.form.company,this.form.period);
                    }
                });
            },
            retry() {
                const that = this;
                this.retryLoading = true
                if (!this.form.materialCode) {
                    return;
                }
                let url = '/certificateManage/efsCapCertificate/getCostCalculation'
                let _request = [{
                    company: this.form.company,
                    period: this.form.period,
                    step: this.steps[this.currentTab]['value'],
                    materialCode: this.form.materialCode,
                }]
                postJsonAction(url, JSON.stringify(_request)).then(res => {
                    this.retryLoading = false;
                    if(res.success){
                        that.$message.success(res.result.message);
                        this.$nextTick(() => {
                            if(this.currentTab==1){
                                this.$refs.efsPayableList.getOrderMain(this.form.company,this.form.period);
                            }else if(this.currentTab==3){
                                this.$refs.efsCostList.getOrderMain(this.form.company,this.form.period);
                            }
                        });
                    }else{
                        that.$message.warning(res.result.message);
                    }

                })
            },
            finish() {
                this.currentTab = 0
            },


        }
    }
</script>

<style lang="less" scoped>
  .steps {
    margin: 16px auto;
  }
</style>